module.exports = __webpack_public_path__ + "img/green_circle.7f231305.png";